import React, { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { CustomerSucessController } from "@talentbait/shared-components";
import LoadingIndicator from "react-loading-indicator";
// Internal dep.
import logger from "../../../utils/LoggerFrontend";
import Actions from "../../../Actions";
import { STATUS_WITH_SET_LIVE } from "../../../PagesUser/SelfServiceCampaignCreation/Previews/constants";
import { useTranslation } from "react-i18next";

//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const ScheduleButtonWrapper = styled.button`
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: ${({ show }) => (!show ? 0 : "50px")};
  margin-bottom: ${({ show }) => (!show ? 0 : "16px")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background: ${({ disabled }) => (disabled ? "#b8bfb7b3" : "rgb(91, 192, 76)")};
  overflow: hidden;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0px 20px;
  text-align: center;
  color: white;
  border-radius: 3px;
  border: 0px;
  outline: none;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background: ${({ disabled }) => (disabled ? "#b8bfb7b3" : "rgb(73, 154, 61)")};
  }
`;
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const ScheduleButton = ({
  status,
  setStatus,
  campaignId,
  userName,
  startDate,
  userProfile,
  setShowStartingDatePanel
}) => {
  // Defines use transaltion object
  const { t } = useTranslation();

  const [isSettingCampaignScheduled, setIsSettingCampaignScheduled] = useState(false);

  const setCampaignScheduled = useCallback(() => {
    const newStatus = "SCHEDULED";
    logger.log("ScheduleButton:setCampaignScheduled", "called", {
      campaignId,
      displayName: userName,
      userProfile,
      startDate,
      status,
      isSettingCampaignScheduled
    });
    if (isSettingCampaignScheduled) {
      return;
    }
    setIsSettingCampaignScheduled(true);

    const ref = Actions.updateCampaignStatus.completed.listen((result) => {
      logger.log("ScheduleButton:setCampaignScheduled", "successfully set campaign scheduled", {
        campaignId,
        displayName: userName,
        result
      });
      Actions.addNotification(t("Campaign was successfully released"));
      setIsSettingCampaignScheduled(false);
      setStatus(newStatus);
      setShowStartingDatePanel(true);
      CustomerSucessController.send("preview:scheduleCampaign", {
        campaignId
      });
      ref();
    });

    const refFailed = Actions.updateCampaignStatus.failed.listen((error) => {
      logger.log("error:ScheduleButton:setCampaignScheduled", "unable to set campaigns scheduled", {
        error,
        campaignId,
        displayName: userName
      });
      setIsSettingCampaignScheduled(false);
      Actions.addNotification(t("Campaign was not released (1)"), "error");
      refFailed();
    });

    Actions.updateCampaignStatus(campaignId, newStatus, userName, true);
  }, [
    userProfile,
    campaignId,
    userName,
    setStatus,
    startDate,
    isSettingCampaignScheduled,
    status,
    setShowStartingDatePanel,
    t
  ]);

  const showCTAButton = useMemo(() => STATUS_WITH_SET_LIVE.includes(status), [status]);

  return (
    <ScheduleButtonWrapper
      show={showCTAButton}
      onClick={setCampaignScheduled}
      disabled={isSettingCampaignScheduled}
    >
      {isSettingCampaignScheduled ? (
        <LoadingIndicator
          color={{
            red: 255,
            green: 255,
            blue: 255,
            alpha: 1
          }}
        />
      ) : (
        t("Approve campaign & start later")
      )}
    </ScheduleButtonWrapper>
  );
};

export default ScheduleButton;
